import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Icon } from "@iconify/react";
import { Link } from "react-router-dom";
import { Col } from "react-bootstrap";
import { gethotelList } from "../store/slices/hotelAdmin";
import ShowSkeleton from "../utils/helpers/skeleton";
import StatusModal from "../utils/Modals/statusModal";

const MyProperty = () => {
  const [data, setData] = useState([]);
  const [selectedItem, setSelectedItem] = useState(null);
  const [actionType, setActionType] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [isloading, setisLoading] = useState(false);
  const itemsPerPage = 50;
  const item = useState({ limit: itemsPerPage });
  const dispatch = useDispatch();

  useEffect(() => {
    setisLoading(true);
    getHAdminLists();
  }, []);

  const getHAdminLists = () => {
    dispatch(gethotelList(item))
      .unwrap()
      .then((data) => {
        setData(data?.hotelData);
      })
      .catch(({ message }) => console.error(message))
      .finally(() => {
        setisLoading(false);
      });
  };

  const openStatusModal = (_id, status) => {
    setSelectedItem({ id: _id, status });
    setActionType(status === 1 ? "deactivate" : "activate");
    setShowModal(true);
  };

  //   const handleStatusChange = () => {
  //     if (selectedItem) {
  //       const { id, status } = selectedItem;
  //       const updatedStatus = status === 1 ? 0 : 1;

  //       const payload = {
  //         id,
  //         status: updatedStatus,
  //       };

  //       dispatch(edithoteladmin(payload))
  //         .unwrap()
  //         .then(() => {
  //           getHAdminLists();
  //           setShowModal(false);
  //         })
  //         .catch((error) => {
  //           console.error("Status update error: ", error);
  //         });
  //     } else {
  //       console.error("No selected item set.");
  //     }
  //   };

  return (
    <>
      {/* <StatusModal
        showModal={showModal}
        actionType={actionType}
        setShowModal={setShowModal}
        handleDelete={handleStatusChange}
      /> */}
      <div className="d-flex flex-wrap align-items-center justify-content-between gap-3 mb-24">
        <h6 className="fw-semibold mb-0">Property</h6>
        <ul className="d-flex align-items-center gap-2">
          <li className="fw-medium">
            <Link
              to="/admin/home"
              className="d-flex align-items-center gap-1 hover-text-primary"
            >
              Home
            </Link>
          </li>
          <li> &gt;</li>
          <li className="fw-medium">Property</li>
        </ul>
      </div>
      <div className="card h-100 p-0 radius-12">
        <div className="card-header bg-base py-16 px-24 d-flex align-items-center flex-wrap gap-3 justify-content-between">
          <div className="d-flex align-items-center flex-wrap gap-3"></div>
          <Link
            to="/admin/add-property"
            className="btn btn-primary text-md btn-sm px-8 py-8 text-sm radius-8 d-flex align-items-center gap-2"
          >
            Add New Property
          </Link>
        </div>
        <div className="card-body px-24 py-2">
          <div className="table-responsive scroll-sm">
            {isloading ? (
              <Col lg={12} xs={12} md={12} align="center">
                {ShowSkeleton()}
              </Col>
            ) : (
              <table className="table striped-table mb-50">
                <thead>
                  <tr>
                    <th scope="col">
                      <div className="d-flex align-items-center gap-10">
                        S.L
                      </div>
                    </th>

                    <th scope="col">Name</th>
                    <th scope="col" className="text-center">
                      Location
                    </th>
                    <th scope="col" className="text-center">
                      Property Type
                    </th>
                    <th scope="col" className="text-center">
                      Total Rooms
                    </th>
                    <th scope="col" className="text-center">
                      Status
                    </th>
                    <th scope="col" className="text-center">
                      Approved
                    </th>
                    <th scope="col" className="text-center">
                      Action
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.map((item, index) => (
                    <tr key={index}>
                      <td>
                        <div className="d-flex align-items-center gap-10">
                          {index + 1}
                        </div>
                      </td>

                      <td>
                        <div className="d-flex align-items-center">
                          <div className="flex-grow-1">
                            <span className="text-md mb-0 fw-normal text-secondary-light">
                              {item.name}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td>
                        <div
                          // className="d-flex align-items-center"
                          className="text-center text-md"
                        >
                          {item.locality.name}
                        </div>
                      </td>
                      <td className="text-center">
                        <div className="text-center">
                          <div className="flex-grow-1">
                            <span className="text-md mb-0 fw-normal text-secondary-light">
                              {item.propertyType.name}
                            </span>
                          </div>
                        </div>
                      </td>
                      <td className="text-center">
                        <div className="d-flex align-items-center justify-content-center">
                          <div className="flex-grow-1">
                            <span className="text-md mb-0 fw-normal text-secondary-light ">
                              {item.availableRooms}
                            </span>
                          </div>
                        </div>
                      </td>

                      <td className="text-center">
                        {item.status === 0 ? (
                          <Link
                            onClick={() =>
                              openStatusModal(item._id, item.isActive)
                            }
                            className="bg-danger-focus text-danger-600 text-md bg-hover-danger-200 fw-medium d-flex justify-content-center align-items-center"
                            style={{
                              borderRadius: "10px",
                              padding: "2px 6px",
                              width: "70px",
                              fontSize: "14px",
                            }}
                          >
                            Inactive
                          </Link>
                        ) : (
                          <Link
                            onClick={() =>
                              openStatusModal(item._id, item.isActive)
                            }
                            className="bg-success-focus text-md text-success-600 bg-hover-success-200 fw-medium justify-content-center align-items-center"
                            style={{
                              borderRadius: "10px",
                              padding: "2px 6px",
                              width: "60px",
                              fontSize: "14px",
                            }}
                          >
                            Active
                          </Link>
                        )}
                      </td>

                      <td className="text-center">
                        {item.isApproved === false && (
                          <Link
                            className="bg-danger-focus text-md text-danger-600 bg-hover-danger-200 fw-medium justify-content-center "
                            style={{
                              borderRadius: "10px",
                              padding: "2px 6px",
                              width: "50px",
                              fontSize: "14px",
                            }}
                          >
                            No
                          </Link>
                        )}
                        {item.isApproved === true && (
                          <Link
                            className="bg-success-focus  text-md text-success-600 bg-hover-success-200 fw-medium  justify-content-center "
                            style={{
                              borderRadius: "10px",
                              padding: "2px 6px",
                              width: "50px",
                              fontSize: "14px",
                            }}
                          >
                            Yes
                          </Link>
                        )}
                      </td>

                      <td className="text-center">
                        <div className="d-flex align-items-left gap-10 justify-content-left">
                          <Link
                            to={`/admin/edit-property/${item._id}`}
                            style={{
                              borderRadius: "10px",
                              padding: "2px 6px",
                              width: "50px",
                              fontSize: "14px",
                            }}
                            className="bg-warning-focus text-warning-600 bg-hover-warning-200 fw-medium justify-content-center align-items-center"
                          >
                            Edit
                          </Link>
                          {item.isApproved === true && (
                            <Link
                              to={`/admin/rooms/${item._id}`}
                              style={{
                                borderRadius: "10px",
                                padding: "2px 6px",
                                width: "80px",
                                fontSize: "14px",
                              }}
                              className="bg-info-border text-primary-500 bg-hover-info-200 fw-medium justify-content-center align-items-center"
                            >
                              Rooms
                            </Link>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default MyProperty;
